import React from 'react';

interface Props {
  summary: string;
}

const SummaryList: React.FC<Props> = ({ summary }) => {
  const items = summary
    .split('\n')
    .map(item => item.trim())
    .filter(item => item); // remove empty lines

  return (
    <ul className="list-disc pl-5 space-y-1">
      {items.map((point, index) => (
        <li key={index}>{point.replace(/^[-•]\s*/, '')}</li>
      ))}
    </ul>
  );
};

export default SummaryList;